import i18next from "i18next";
import common_de from "../../translations/de/common.json";
import common_en from "../../translations/en/common.json";
import apierror_de from "../../translations/de/apierror.json";
import apierror_en from "../../translations/en/apierror.json";
import validation_de from "../../translations/de/validation.json";
import validation_en from "../../translations/en/validation.json";
import { changeMomentLang } from "./momentLocale";

changeMomentLang("en");

const commonEn = { ...common_en, ...apierror_en, ...validation_en };
const commonDe = { ...common_de, ...apierror_de, ...validation_de };

export const i18nInit = () => {
  i18next.init({
    interpolation: { escapeValue: false }, // React already does escaping
    lng: "en", // language to use
    resources: {
      en: {
        common: commonEn // 'common' is our custom namespace
      },
      de: {
        common: commonDe
      }
    }
  });

  return i18next;
};
